import IconCheckmark from '../icons/IconCheckmark';

type Props = {
    className?: string;
    attributes?: React.InputHTMLAttributes<HTMLInputElement>;
    label?: string;
};

const Checkable: React.FC<Props> = ({ className = '', attributes = {}, label = 'Label' }) => {
    return (
        <div className={`fireknife-checkable-box ${className}`}>
            <label className="fireknife-checkable">
                <input type="radio" className="fireknife-checkable__form-control" {...attributes} />
                <span className="fireknife-checkable__icon-box">
                    <IconCheckmark className="fireknife-checkable__icon" />
                </span>
                <span className="fireknife-checkable__text">{label}</span>
            </label>
        </div>
    );
};

export default Checkable;
